<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-alert :show="feedback.show" dismissible :variant="feedback.variant" @dismissed="feedback.show = 0" @dismiss-count-down="countDownChanged">
                {{ feedback.text }}
                <ul v-if="errors" class="mt-3">
                  <li v-for="error in errors">
                    {{ error.toString() }}
                  </li>
                </ul>
              </b-alert>
            </b-col>
            <b-col cols="12">
              <b-card>
                <template #header>
                  <strong>Gebruiker {{item.name}} (# {{item.id}})</strong>
                </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="E-mailadres">
                          <b-form-input type="email" required v-model="item.email" :disabled="!editable"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Rechtenprofiel">
                          <b-form-select :options="roleOptions" v-model="item.role" :disabled="!editable"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4" v-if="['Manager', 'Analyst','Filiaalmanager', 'Gebruiker'].indexOf(item.role) > -1">
                      <b-col cols="12" md="8">
                        <h5 v-if="['Manager', 'Analyst'].indexOf(item.role) > -1">Bedrijf</h5>
                        <h5 v-if="['Gebruiker', 'Filiaalmanager'].indexOf(item.role) > -1">Locatie</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="6" v-if="['Manager', 'Analyst'].indexOf(item.role) > -1">
                        <b-form-group label="Gekoppeld bedrijf">
                          <b-form-select :options="companyOptions" v-model="item.company_id" :disabled="!editable"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" v-if="['Gebruiker', 'Filiaalmanager'].indexOf(item.role) > -1">
                        <b-form-group label="Gekoppelde locatie">
                          <b-form-select :options="locationOptions" v-model="item.location_id" :disabled="!editable"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Permissies</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="6" class="mt-2 mb-4" v-if="item.role">
                        <b-form-checkbox-group :options="portalPermissions" :checked="activePortalPermissions" :disabled="true" stacked></b-form-checkbox-group>
                      </b-col>
                      <b-col cols="12" md="10" class="mt-2 mb-4" v-else>
                        <p style="font-style: italic; color: #73818f;">Selecteer een rechtenprofiel om de permissies te bekijken</p>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="12" md="8">
                        <h5>Aanvullende permissies</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" class="mt-2 mb-4">
                        <b-form-checkbox v-model="item.active" value="1" unchecked-value="0" :disabled="!editable">
                          Deze gebruiker kan gebruik maken van de portal
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="12" v-can="'gebruikers aanpassen'" v-if="editable" class="mb-4">
              <b-card>
                <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                <b-button @click.prevent="cancelEdit">Annuleren</b-button>
              </b-card>
            </b-col>
            <b-col cols="12" v-can="'gebruikers aanpassen'" v-if="!editable" class="mb-4">
              <b-card>
                <b-button type="button" @click.prevent="editable = true" variant="primary" v-can="'gebruikers aanpassen'" class="mr-3">Bewerken</b-button>
                <b-button type="button" @click.prevent="resendInvite" :disabled="resendInviteButtonDisabled" variant="dark" v-can="'gebruikers aanpassen'">Uitnodiging versturen</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { updateData, getData, addData } from '../../api';

export default {
  name: 'user',
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      resendInviteButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4,
      },
      errors: null,
      editable: false,
      companyOptions: [],
      locationOptions: [],
      roleOptions: [],
      item: {
        name: '',
        email: '',
        company_id: null,
        location_id: null,
        role: null,
      },
    };
  },
  methods: {
    async getItem() {
      const item = await getData('users/' + this.$route.params.id).then(
        (response) => response.data
      );
      this.item = item.data;
    },
    async getCompanyOptions() {
      const options = await getData('companies/options').then(
        (response) => response.data
      );
      this.companyOptions = [
        { text: 'Geen bedrijf', value: null },
        ...options.data
      ];
    },
    async getLocationOptions() {
      const locations = await getData('locations/options').then(
        (response) => response.data
      );
      this.locationOptions = [
        { text: 'Geen locatie', value: null },
        ...locations.data
      ];
    },
    async getRoleOptions() {
      const roles = await getData('auth/roles').then(response => response.data);
      this.roleOptions = roles.data.map((item) => {
        return {
          text: item.name,
          value: item.name,
          permissions: item.permissions
        };
      });
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData(
        'users/' + this.$route.params.id,
        this.item
      );
      if (request.status === 200) {
        this.feedback.show = true;
        this.feedback.text = 'Gebruiker succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
        await this.getItem();
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs;
    },
    async resendInvite() {
      this.resendInviteButtonDisabled = true;
      const request = await addData('users/send-invite', {
        user_id: this.$route.params.id,
      });
      if (request.status === 200) {
        alert('Uitnodiging verstuurd');
      } else {
        alert('Er is iets misgegaan...');
        this.resendInviteButtonDisabled = false;
      }
    },
    getAllData() {
      return new Promise(async (resolve) => {
        await this.getCompanyOptions();
        await this.getLocationOptions();
        await this.getRoleOptions();
        resolve();
      });
    }
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    portalPermissions() {
      let permissions = [];

      if (this.item.role) {
        const profile = this.roleOptions.find(item => {
          return item.value === this.item.role
        });

        if (profile) {
          permissions = profile.permissions.map(item => {
            return {
              text: item.name,
              value: item.id,
              checked: true
            }
          });
        }
      }

      return permissions;
    },
    activePortalPermissions() {
      return this.portalPermissions.map(item => item.value);
    }
  },

  watch: {
    'item.role'(newValue) {
      if (['Gebruiker', 'Filiaalmanager'].indexOf(newValue) > -1) {
        this.item.company_id = null;
        this.getLocationOptions();
      }
      else if (['Manager', 'Analyst'].indexOf(newValue) > -1) {
        this.item.location_id = null;
        this.getCompanyOptions();
      }
      else {
        this.item.company_id = null;
        this.item.location_id = null;
        this.getAllData();
      }
    }
  },

  async beforeMount() {
    return await this.getItem().then(async() => {
      return await this.getAllData();
    });
  },
};

</script>
